import { gql } from "@apollo/client";

export const GET_SELLERS = gql`
query GetSellers($pageOptions: PageOptions, $filters: [SellersFilters], $sortOptions: [SortOptions]) {
  getSellers(pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
    TOTAL_COUNT
    data {
      ARCIMEDES_ROW_ID
      STATUS
      AGENT
      FIRST_NAME
      LAST_NAME
      COMPANY_NAME
      COMPANY_ADDRESS
      COMPANY_CITY
      COMPANY_STATE
      COMPANY_ZIP
      PHONE
      EMAIL
      NOTES
      PROFILE
      CELL_PHONE
      LAST_MODIFIED
      DELETED
      ARCIMEDES_CREATED
      ARCIMEDES_CREATED_BY
      ARCIMEDES_MODIFIED
      ARCIMEDES_MODIFIED_BY
     
    }
    success
  }
}
`;

// first_name
// last_name
// phone
// email
// profile
// notes
// company_name
// company_address
// company_city
// company_state
// company_zip

export const GET_SELLERS_BY_ID = gql`
query GetSeller($arcimedesRowId: ID!) {
  getSeller(arcimedes_row_id: $arcimedesRowId) {
    data {
      ARCIMEDES_ROW_ID
      STATUS
      AGENT
      FIRST_NAME
      LAST_NAME
      COMPANY_NAME
      COMPANY_ADDRESS
      COMPANY_CITY
      COMPANY_STATE
      COMPANY_ZIP
      PHONE
      EMAIL
      NOTES
      PROFILE
      CELL_PHONE
      LAST_MODIFIED
      DELETED
      ARCIMEDES_CREATED
      ARCIMEDES_CREATED_BY
      ARCIMEDES_MODIFIED
      ARCIMEDES_MODIFIED_BY
    }
    message
    success
  }
}
`
export const GET_SELLERS_WTH_FILTERS = gql`
query getSeller($pageOptions: PageOptions,$filters: [Filters], $sortOptions: [SortOptions]) {
    getAgents(pageOptions: $pageOptions, filters: $filters, sortOptions: $sortOptions) {
        agents{
        arcimedes_row_id
        first_name
        last_name
        phone
        cell_phone
        email
        firm 
        deleted
        arcimedes_created
        arcimedes_created_by
        arcimedes_modified
        arcimedes_modified_by
        }
        totalCount
    }
}
`